import { NodeView } from "prosemirror-view";

/**
 * Isolate a node view to prevent the editor from reacting to events handled within the node view.
 * @param nodeView The node view to isolate.
 */
export function isolateNodeView(nodeView: NodeView): NodeView {
  return { stopEvent: () => true, ignoreMutation: () => true, ...nodeView };
}

/**
 * Set attributes on a node view.
 * @param dom The node view's DOM element.
 * @param attrs The attributes to set.
 */
export function setNodeViewAttrs(dom: HTMLElement, attrs: Record<string, unknown>): void {
  Object.entries(attrs).forEach(([key, value]) => {
    if (value != null) {
      dom.setAttribute(key, value.toString());
    }
  });
}
